import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import Modal from "react-responsive-modal";

export default function PirCaptureAlertModal(props) {
    return (
        <Modal open={props.show} onClose={props.onCloseClicked}>
            <h4 style={{width: "1000px"}}> This action will toggle 'pir-capture' state on the device, are you sure you want to continue ? </h4>
            <Row>
                    <div style={{marginTop: 4,marginLeft:15}}>
                        click 'Proceed' to continue.
                    </div>
            </Row>
            <Row>
                <Col sm={12}>
                <Button variant="primary" style={{margin: 20}}
                        onClick={props.onContinueClicked}>Proceed</Button>
                </Col>
            </Row>
        </Modal>
    )
}
